import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiServiceService } from '../../services/api-service.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Conditional } from '@angular/compiler';
import { MyorderListComponent } from '../myorder-list/myorder-list.component';

@Component({
  selector: 'app-my-order-cancel-model',
  templateUrl: './my-order-cancel-model.component.html',
  styleUrl: './my-order-cancel-model.component.scss'
})
export class MyOrderCancelModelComponent {

  showPage: boolean = true;
  showInput: boolean = true;
  cancelProductId: any;
  cancelId: any;
  cartid : any;
    orderdata: any;   // <-- add this
  videoFile: any;
  togglePage() {
    this.showPage = !this.showPage;
  }

  togglePageinput(show: boolean){
this.showInput =!this.showInput
  }

  // public cancelReason!: FormGroup;
// ✅ now class-level orderdata

  selectedChoice: string = 'option1';
  otherIssue: any;

  onInputChange() {
    // You can add custom logic here if needed
  }

  constructor(private router:Router, private fb: FormBuilder, private toastr:ToastrService, private activeRouter:ActivatedRoute, private api:ApiServiceService  ,public dialogRef: MatDialogRef<MyOrderCancelModelComponent > , @Inject(MAT_DIALOG_DATA) public data: any){


   

    
    
  }
  ngOnInit(){
    
    const cancelProductId = this.data.id._id;
     this.orderdata = this.data.id;   // <-- assign the whole object, not just status

    console.log('orderdata:', this.orderdata.order_status);
    console.log('productid' , cancelProductId)
}
  
orderCancel() {
  const payload = {
    selectedChoice: this.selectedChoice,
    otherIssue: this.selectedChoice === 'other' ? this.otherIssue : null
  };

  this.api.orderCancel(this.data.id._id, payload, this.videoFile).subscribe(
    (res: any) => {
      if (res.success || res.message.includes('canceled')) {
        this.toastr.success(res.message);
        this.dialogRef.close({ success: true });
      } else {
        this.toastr.error(res.message || 'Cancellation failed');
      }
    },
    error => {
      this.toastr.error('Server error occurred');
      console.error(error);
    }
  );
}


 // ✅ check 7 days from createdAt
  isWithin7Days(createdAt: string | Date): boolean {
    if (!createdAt) return false;
    const now = new Date();
    const createdDate = new Date(createdAt);
    const diffDays = Math.floor((+now - +createdDate) / (1000 * 60 * 60 * 24));
    console.log('Days since created:', diffDays);
    return diffDays <= 7;
  }


  onNoClick(): void {
    this.dialogRef.close();
  }

  
}

